export default __webpack_public_path__ + "static/media/send-icon.e2a58422.svg";